// Conteos centralizados de los badges del Home y dashboards. Todos aplican el corte
// FECHA_CORTE (1-ene-2026): las facturas/movimientos históricos pre-Clay no inflan los
// badges. Las facturas recibidas excluyen NCs (tipo_dte=61): reducen deuda, no son DTEs
// pendientes pagables. La regla vive acá una sola vez — consumidores: Admin Home y
// DashboardFinanciero.
import { FECHA_CORTE } from "./estadoCuenta/saldoInicial";
import { client } from "./supabase";

// Facturas SII recibidas pendientes desde el corte, excluyendo NCs (tipo_dte=61).
export async function getCountRecibidasPendientes(pais) {
  const { count } = await client
    .from("facturas_sii_recibidas")
    .select("id", { count: "exact", head: true })
    .eq("pais", pais)
    .eq("estado_vinculacion", "pendiente")
    .gte("fecha_emision", FECHA_CORTE)
    .neq("tipo_dte", 61);
  return count || 0;
}

// Movimientos bancarios sin vincular desde el corte (sin FK emitida/recibida/caja, no ignorados).
export async function getCountMovimientosPendientes(pais) {
  const { count } = await client
    .from("movimientos_bancarios")
    .select("id", { count: "exact", head: true })
    .eq("pais", pais)
    .gte("fecha", FECHA_CORTE)
    .is("factura_sii_emitida_id", null)
    .is("factura_sii_recibida_id", null)
    .is("movimiento_caja_id", null)
    .neq("estado", "ignorado");
  return count || 0;
}

// Movimientos bancarios vinculados a pagos de empleados (se restan del badge de Caja).
export async function getCountPagosEmpleadoMovs(pais) {
  const { count } = await client
    .from("movimientos_bancarios")
    .select("id, pagos_empleados!inner(id)", { count: "exact", head: true })
    .eq("pais", pais);
  return count || 0;
}

// Badge compuesto "Caja": movimientos pendientes + recibidas pendientes − pagos a empleado.
export async function getCountCajaPendientes(pais) {
  const [movs, recibidas, pagos] = await Promise.all([
    getCountMovimientosPendientes(pais),
    getCountRecibidasPendientes(pais),
    getCountPagosEmpleadoMovs(pais),
  ]);
  return movs + recibidas - pagos;
}
